import { track } from '@bnnvara/analytics/src/track';
import { BaseButton } from '@bnnvara/buttons';
import { Heading, Text } from '@bnnvara/typography';
import Link from 'next/link';
import React from 'react';

import * as S from './styled';

export const DonationSuccess = () => (
  <S.Wrapper align="center">
    <Heading element="h2" variant="two" textTransform="none" textAlign="center">
      Beste donateur,
    </Heading>
    <Text center>
      <br />
      Hartelijk dank voor jouw donatie! Dankzij jouw donatie kunnen wij nog meer
      acties opzetten en programma’s maken waarmee we zaken aan de kaak stellen
      en informatie bieden aan een breed en jong publiek.
    </Text>
    <S.Image
      src="/static/statusImages/donate_success.png"
      alt="Het doneren is gelukt"
    />
    <Link href="/jaaroverzicht" passHref>
      <BaseButton
        fullWidth
        type="link"
        onClick={() => track('donatie-gelukt', 'click', 'naar-jaaroverzicht')}
      >
        Naar het jaaroverzicht van BNNVARA
      </BaseButton>
    </Link>
  </S.Wrapper>
);
